// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShowAllTags_wrapper__YWMpx","title":"ShowAllTags_title__3vjx9","open":"ShowAllTags_open__2vngB"};